import React, { useRef, useEffect } from 'react';
import Slider from "react-slick";
import { AppContext } from '../App';
import { useContext } from 'react';
import banner1 from '../assets/banner1.jpg';
import banner2 from '../assets/banner2.jpg';
import banner3 from '../assets/banner3.jpg';
import banner4 from '../assets/banner4.jpg';
import banner5 from '../assets/banner5.jpg';
import banner6 from '../assets/banner6.jpg';
import banner7 from '../assets/banner7.jpg';
import logo_icon from '../assets/logo_icon.png';
import { IoMdCheckmarkCircleOutline } from 'react-icons/io';

export default function HomeSlider() {
	const sliderRef = useRef(null);
	const appContext = useContext(AppContext);

	const banners = [banner5, banner7, banner1, banner2, banner3, banner4, ];


	useEffect(() => {
		const slider = sliderRef.current;

		const preventTouchEvents = (e) => {
			e.stopPropagation(); // Prevent the event from reaching the parent
		};

		if (slider) {
			// Attach event listeners to prevent touch events from propagating to parent
			slider.addEventListener('touchstart', preventTouchEvents);
			slider.addEventListener('touchmove', preventTouchEvents);
			slider.addEventListener('touchend', preventTouchEvents);
		}

		return () => {
			if (slider) {
				// Clean up the event listeners when the component is unmounted
				slider.removeEventListener('touchstart', preventTouchEvents);
				slider.removeEventListener('touchmove', preventTouchEvents);
				slider.removeEventListener('touchend', preventTouchEvents);
			}
		};
	}, []);

	const settings = {
		dots: false,
		infinite: true,
		speed: 800,
		slidesToShow: 1,
		slidesToScroll: 1,
		autoplay: true,
		autoplaySpeed: 6000,
		arrows: false,
		pauseOnHover: false,   // 👈 keep autoplay running when hovering
  	pauseOnFocus: false,   // 👈 keep autoplay running when focused
	};

	return (
		<div className='WelcomeSlider' ref={sliderRef}>
			<Slider {...settings}>
				
				<div
					style={{
						width: "100%",
						height: "auto",
						overflow: "hidden",
						
					}}
				>
					<div
						style={{
							width: "100vw",
							height: "calc(100vh - var(--topBarHeight))",
							background: "rgba(0, 0, 0, 0.5)",
							position: "relative",
							zIndex: 1,
							backgroundImage: `url(${banner1})`,
							backgroundAttachment: "fixed",
							backgroundSize: "cover",
							backgroundPosition: "center",
						}}
					>

					
						<div
							style={{
								width: "100%",
								height: "100%",
								background: "rgba(0, 0, 0, 0.7)",
							}}
						>
							<div className="container">
								<div className="row">
									
									<div className="col-md-12">
                    <img
                      src={logo_icon}
                      style={{
                        width: "100px",
                        paddingTop: "70px",
                      }}
                    />

										<h1
											className="font-light text-light"
											style={{
												fontSize: "72px",
												
												textTransform: "uppercase",
											}}
										>
                  
											TYIDI
											<span
												style={{
													fontSize: "32px",
													borderBottom: "4px solid var(--secondaryColor)",
													paddingBottom: "20px"
												}}
												className='d-block font-light'
											>
												Tanzania Youth Integrated Development Initiative
											</span>
										</h1>

										<h1
											className="font-bold text-light"
											style={{
												fontSize: "28px",
												paddingTop: "20px",
												paddingBottom: "10px",
												textTransform: "uppercase",
											}}
										>
											Youth-led, Non-Governmental, Non-Profit Organization
											
										</h1>

										
										
										<div 
											className="text-end"
											style={{
												paddingTop: "10px"
											}}
										>
											

											<button
												className="btn btn-padded btn-rounded btn-outline-light"
												style={{
													margin: "0px",
													
												}}
												onClick={() => {
													appContext.navTo({
														item: 'about_us'
													})
												}}
											>
												About Us
											</button>
										</div>

									</div>

									

								</div>
							</div>
						</div>
						
					</div>
				</div>

				<div
					style={{
						width: "100%",
						height: "auto",
						overflow: "hidden",
						
					}}
				>
					<div
						style={{
							width: "100vw",
							height: "calc(100vh - var(--topBarHeight))",
							background: "rgba(0, 0, 0, 0.5)",
							position: "relative",
							zIndex: 1,
							backgroundImage: `url(${banner3})`,
							backgroundAttachment: "fixed",
							backgroundSize: "cover",
							backgroundPosition: "center",
						}}
					>

					
						<div
							style={{
								width: "100%",
								height: "100%",
								background: "rgba(0, 0, 0, 0.7)",
							}}
						>
							<div className="container">
								<div className="row">
									
									<div className="col-md-12">
										<h1
											className="font-light text-light"
											style={{
												fontSize: "24px",
												paddingTop: "30px",
												textTransform: "uppercase",
											}}
										>
											The Tanzania Youth Integrated Development Initiative (TYIDI) addresses challenges facing youth in the agricultural value chain.
										</h1>

										<h1
											className="font-light text-light"
											style={{
												fontSize: "20px",
												paddingTop: "20px",
												paddingBottom: "10px",
											}}
										>
											Strategic focus areas:
										</h1>


										<h1
											className="font-bold text-light"
											style={{
												fontSize: "14px",
												textTransform: "uppercase",
											}}
										>
											<IoMdCheckmarkCircleOutline size={32} /> Youth Empowerment and Livelihoods
										</h1>

										<h1
											className="font-bold text-light"
											style={{
												fontSize: "14px",
												textTransform: "uppercase",
											}}
										>
											<IoMdCheckmarkCircleOutline size={32} />  Sustainable Agriculture and Food Security
										</h1>
										
										<h1
											className="font-bold text-light"
											style={{
												fontSize: "14px",
												textTransform: "uppercase",
											}}
										>
											<IoMdCheckmarkCircleOutline size={32} /> Renewable Energy and Environmental Sustainability
										</h1>

										<h1
											className="font-bold text-light"
											style={{
												fontSize: "14px",
												textTransform: "uppercase",
											}}
										>
											<IoMdCheckmarkCircleOutline size={32} /> Health and Wellbeing
										</h1>

                    <h1
											className="font-bold text-light"
											style={{
												fontSize: "14px",
												textTransform: "uppercase",
											}}
										>
											<IoMdCheckmarkCircleOutline size={32} /> Education and Skills Development
										</h1>

                    <h1
											className="font-bold text-light"
											style={{
												fontSize: "14px",
												textTransform: "uppercase",
											}}
										>
											<IoMdCheckmarkCircleOutline size={32} /> Research, Policy, and Advocacy
										</h1>

										
										
										<div className="text-end mt-5">
											<button
												className="btn btn-padded btn-rounded btn-primary"
												style={{
													margin: "10px",

												}}
												onClick={() => {
													appContext.navTo({
														item: 'about_us'
													})
												}}
											>
												Contact Us
											</button>

											
										</div>

									</div>

									

								</div>
							</div>
						</div>
						
					</div>
				</div>

				
				
			</Slider>
		</div>
	);
}
